module.exports = __webpack_public_path__ + "7fca8fa6064892525f518b709f1a0d6f.pdf";